import { render } from "./ReceiptsPanel.vue?vue&type=template&id=9fa006ae"
import script from "./ReceiptsPanel.vue?vue&type=script&lang=js"
export * from "./ReceiptsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__